export default {
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Inativar',
      title: 'Confirmar Inativação',
      message: `Deseja inativar o convênio <b>${this.currentEntity.covenant.name}</b>?`
    }
  },
  getMessageActive () {
    return {
      cancel: 'Cancelar',
      label: 'Ativar',
      title: 'Confirmar Ativação',
      message: `Deseja ativar o convênio <b>${this.currentEntity.covenant.name}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/resources/computed.js